import styled from "styled-components";
import { Type, Flex } from "discover.medical.react-component-library";

export const StyledHeading = styled(Type)`
  margin-bottom: ${({ theme }) => theme.space.lg};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-bottom: ${({ theme }) => theme.space.xl};
  }
`;

export const StyledTOCHolder = styled(Flex)`
  padding-top: ${({ theme }) => theme.space.sm};
  padding-bottom: ${({ theme }) => theme.space.xl};

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-right: ${({ theme }) => theme.space.xxxl};
    padding-bottom: 0;
  }
`;

export const StyledContentHolder = styled(Flex)`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
    padding-right: 15rem;
  }
`;
